import { useState } from 'react';
import { FieldValues } from 'react-hook-form';

import { CreateOrderForm } from 'components/CreateOrderForm';
import { Modal } from 'components/Modal';

import * as S from './OrderModal.styles';
import { StepOne } from './components/StepOne';

type NoOrderModalProps = {
  onClose: () => void;
  onSubmit: (data: FieldValues) => void;
  isLoading?: boolean;
};

export function OrderModal(props: NoOrderModalProps): React.ReactElement {
  const { onClose, onSubmit, isLoading = false } = props;

  const [isStepTwo, isStepTwoSet] = useState<boolean>(false);

  return (
    <Modal onClose={onClose}>
      <S.Container>
        {isStepTwo ? (
          <CreateOrderForm onSubmit={onSubmit} isLoading={isLoading} />
        ) : (
          <StepOne onClose={onClose} isStepTwoSet={isStepTwoSet} />
        )}
      </S.Container>
    </Modal>
  );
}
